import {Component, Input, OnInit} from '@angular/core';
import {AuthService} from '../../../shared/services/auth.service';
import {RewardsSummaryService} from '../../../shared/services/rewards-summary.service';
import {ParamService} from '../../../shared/services/param.service';
import {properties} from '../../../../environments/properties';
declare const $: any;
@Component({
  selector: 'loyalty-birthday-rewards',
  templateUrl: './loyalty-birthday-rewards.component.html',
  styleUrls: ['./loyalty-birthday-rewards.component.scss']
})
export class LoyaltyBirthdayRewardsComponent implements OnInit {
  dataCommonError = 'Unknown error occured. Please try again later.';
  @Input() userInfo;
  @Input() banner: any;
  @Input() currentEnvironment: any;
  @Input() appHostURL: any;
  @Input() userProfile: any;
  enableBirthDayModule: boolean;
  enableFuelStation: boolean;
  showBirthdayContainer = true;
  apiInProgress = false;

  constructor(public authService: AuthService, private _rewardSummaryService: RewardsSummaryService, private paramService: ParamService) { }

  ngOnInit(): void {
    this.enableBirthDayModule = properties.rewardsConfig.enableBirthdayModule;
    this.enableFuelStation = properties.rewardsConfig.enableFuelStationModule;
    if (this.userProfile && this.userProfile.age && this.userProfile.age.dateOfBirth) {
      this.showBirthdayContainer = false;
    }
  }
  initBirthdayRewardModUnits(profile: any, event) {
    const brComponents = $('.loyalty-birthday-rewards-mod-unit');

    if (brComponents.length > 0) {
      event.stopPropagation();
      event.preventDefault();

      $('#birthday-mod-unit-modal').modal();
      if (window['AB'] && window['AB'].DATALAYER) {
        window['AB'].DATALAYER.setModalViewEvents('add-birthday|view');
      }
      this.initModalFormEvents();
    }
  };

  initModalFormEvents() {
    // Month onChange
    const birthDayModal = $('#birthday-mod-unit-modal');
    const form = birthDayModal.find('form');
    const monthSelect = birthDayModal.find('select[name="dob-month"]');
    const daySelect = birthDayModal.find('select[name="dob-day"]');
    const _this = this;
    _this['form'] = form;
    form.on('submit', async function (e) {
      e.preventDefault();
      e.stopPropagation();

      const thisForm = $(this);
      const errorContainer = $('#error-message');
      errorContainer.empty();

      thisForm.addClass('was-validated');

      const monthSelect = $('#dob-month');
      const daySelect = $('#dob-day');

      if (!monthSelect.val()) {
        _this.handleValidationFailure(monthSelect);
      } else if (!daySelect.val()) {
        _this.handleValidationFailure(daySelect);
      } else {
        const month = monthSelect.val().padStart(2, '0');
        const day = daySelect.val().padStart(2, '0');
        const dateOfBirth = `2996-${month}-${day}`;
        const dataObj = {
          personalInfo : {
            age: {
              dateOfBirth: dateOfBirth
            }
          }
        };
        _this.apiInProgress = true;
        _this._rewardSummaryService.updateBirthdayUCA(dataObj, _this.userInfo, _this.currentEnvironment).subscribe((data: any) => {
          _this.apiInProgress = false;
          if (data?.personalInfo?.age?.dateOfBirth) {
            _this.handleSuccess();
          }
        }, error => {
          _this.apiInProgress = false;
          console.log(error);
          errorContainer.empty();
          console.error(error);
          let errors: any;
          if(error?.responseJSON?.subErrors) {
            errors = error?.responseJSON?.subErrors;
          } else {
            errors = [
              {message: 'Apologies, we\'re having trouble with our system, please try again later.'}
            ];
          }
          _this.displayErrorMessages(errors);
        });


      }
    });

    monthSelect.on('change', function () {
      if (this.value) {
        const selectedMonthOption = $('option:selected', this);
        const dataDays = selectedMonthOption.attr('data-days');
        daySelect.find('option:not([value=""])').remove();
        for (let i = 1; i <= dataDays; i++) {
          daySelect.append($('<option value="' + i + '">' + i + '</option>'));
          daySelect.removeAttr('disabled');
        }
      }
    });

    $('#bdaymodelconfirmbtn').keydown(function (event) {
      if (event && event.which === 9) {
        if (event.shiftKey === false) {
          event.preventDefault();
          setTimeout(() => {
            document.getElementById('bdaymodelclose').focus();
          }, 100);
        }
      }
    });

    $('#bdaymodelclose').keydown(function (event) {
      if (event && event.which === 9) {
        if (event.shiftKey === true) {
          event.preventDefault();
          setTimeout(() => {
            document.getElementById('bdaymodelconfirmbtn').focus();
          }, 100);
        }
      }
    });

  }

  handleValidationFailure(inputElement) {
    this['form'].removeClass('was-validated');
    inputElement.focus();
    this['form'].addClass('was-validated');
  }

  handleSuccess() {
    const birthDayModal = $('#birthday-mod-unit-modal');  // Adjust the actual modal ID
    birthDayModal.modal('hide');

    const successModal = $('#birthday-success-mod-unit-modal');  // Adjust the actual success modal ID
    successModal.modal();

    window['AB'].LOYALTY.updateUIForBirthDayRemoval();

    if (window['AB'] && window['AB'].DATALAYER) {
      window['AB'].DATALAYER.setModalClickEvents('add-birthday|confirm');
    }

    $('#bdaymodelsuccessbtn').on('keydown', function (event) {
      this.handleTabKey(event, 'bdaysuccessclose');
    });

    $('#bdaysuccessclose').on('keydown', function (event) {
      this.handleShiftTabKey(event, 'bdaymodelsuccessbtn');
    });
  }

  displayErrorMessages(errors) {
    const errorContainer = $('#error-message');
    errorContainer.empty();

    if (errors) {
      errors.forEach(error => {
        errorContainer.append($('<span></span>').text(error.message));
      });
    }
  }

  handleTabKey(event, nextElementId) {
    if (event.which === 9 && !event.shiftKey) {
      event.preventDefault();
      setTimeout(() => {
        document.getElementById(nextElementId).focus();
      }, 100);
    }
  }

  handleShiftTabKey(event, previousElementId) {
    if (event.which === 9 && event.shiftKey) {
      event.preventDefault();
      setTimeout(() => {
        document.getElementById(previousElementId).focus();
      }, 100);
    }
  }

  updateUIForBirthDayRemoval() {
    const brComponents = $('.loyalty-birthday-rewards-mod-unit');

    const birthDayExpFragContainer = brComponents.find('.birthday-mod-unit-container');

    if (birthDayExpFragContainer.length > 0) {
      birthDayExpFragContainer.remove();

      brComponents.find('.reward-mod-unit-container').removeClass('col-lg-6 col-md-6').addClass('col-12');
      // $mod-unified-desktop$
      const pic = brComponents.find('picture.mod-unit__image');
      const img = pic.find('img');

      const tabViewSrc = img.attr('src');
      const deskViewSrc = img.attr('src');

      // Add sources inside the picture and remove the old one.
      pic.find('source').remove();
      pic.prepend($('<source media="(max-width: 1023px)" srcset="' + tabViewSrc + '">'));

      img.attr('src', deskViewSrc.replace('$mod-unified-tab-view$', '$mod-unified-desktop$'));
    }
  }

}
